import React, { Component } from 'react';
import { connect } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Calendar } from 'primereact/calendar';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import moment from 'moment';

import Messages from '../../../shared/UI/Messages/Messages';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import axios from '../../../axios-url';
import { HASACCESS, scrollToTop } from '../../../shared/utility';
import { Companyid, DATATABLE_CONFIG, DROPDOWN_CONFIG, USER_SUBMENU_ID } from '../../../shared/Config';
import * as actions from '../../../store/actions/index';


class Soldout extends Component {

    statusOptions = [
        { label: 'Sold Out', value: 'SOLDOUT' },
        { label: 'Available', value: 'AVAILABLE' }
    ];

    sourceOptions = [
        { label: 'Manual', value: 'MANUAL' },
        { label: 'Auto', value: 'AUTO' }
    ];

    reasonCodeOptions = [
        { label: 'Out of Stock', value: 'OUT_OF_STOCK' },
        { label: 'Ingredient Shortage', value: 'INGREDIENT_SHORTAGE' },
        { label: 'Kitchen Closed', value: 'KITCHEN_CLOSED' },
        { label: 'Quality Issue', value: 'QUALITY_ISSUE' },
        { label: 'Demand Exceeded', value: 'DEMAND_EXCEEDED' },
        { label: 'Other', value: 'OTHER' }
    ];

    state = {
        type: 'add',
        MenuItemSoldOutId: '',
        OutletId: '',
        MenuItemId: '',
        ChannelId: null,
        AvailabilityDate: null,
        StartTime: null,
        EndTime: null,
        Status: '',
        AvailableQty: '',
        SoldQty: '',
        ReasonCode: '',
        Remarks: '',
        Source: '',
        AutoSoldOut: false,
        IsOverride: false,
        OverrideQty: '',
        ModifiedBy: null,
        ModifiedDate: null,
        OrderTypes: null,
        CompanyId: this.props.loggedUserDetail.CompanyId,
        Createdby: (this.props.loggedUserDetail.empID) ?? 'Admin',
        Createddate: new Date(),
        touch: false,
        statusMap: {}
    }

    componentDidMount() {
        this.getAccess = HASACCESS(USER_SUBMENU_ID);
        this.props.getMasterKeywordList('Branch');
        this.props.getMasterKeywordList('MenuItem');
        this.props.getMasterKeywordList('OrderType');
        this.props.getMasterTableList('res/GetmenuitemsoldoutList', Companyid);
    }

    componentDidUpdate(prevProps) {
        if (this.props.tableLists !== prevProps.tableLists && this.props.tableLists && this.props.tableLists.length > 0) {
            const statusMap = {};
            this.props.tableLists.forEach(item => {
                statusMap[item.menuItemSoldOutId] = item.status || 'AVAILABLE';
            });
            this.setState({ statusMap });
        }
    }

    lookupLabel = (list, value) => {
        if (!value) { return ''; }
        let match = (list || []).find(item => item.value === value);
        return match ? match.label : value;
    }

    populateForm = (data, type) => {
        let currentDate = moment().format('DD-MMM-YYYY');
        this.setState({
            type: type,
            MenuItemSoldOutId: data.menuItemSoldOutId,
            CompanyId: (data.companyId !== null && data.companyId !== undefined) ? data.companyId : this.state.CompanyId,
            OutletId: data.outletId || '',
            MenuItemId: data.menuItemId || '',
            ChannelId: data.channelId || '',
            AvailabilityDate: data.availabilityDate ? new Date(data.availabilityDate) : null,
            StartTime: data.startTime ? new Date(currentDate + ' ' + data.startTime) : null,
            EndTime: data.endTime ? new Date(currentDate + ' ' + data.endTime) : null,
            Status: data.status || 'SOLDOUT',
            AvailableQty: (data.availableQty !== null && data.availableQty !== undefined) ? data.availableQty : '',
            SoldQty: (data.soldQty !== null && data.soldQty !== undefined) ? data.soldQty : '',
            ReasonCode: data.reasonCode || '',
            Remarks: data.remarks || '',
            Source: data.source || 'MANUAL',
            AutoSoldOut: data.autoSoldOut === true,
            IsOverride: data.isOverride === true,
            OverrideQty: (data.overrideQty !== null && data.overrideQty !== undefined) ? data.overrideQty : '',
            Createdby: data.createdBy || this.state.Createdby,
            Createddate: data.createdDate ? new Date(data.createdDate) : this.state.Createddate,
            ModifiedBy: (data.modifiedBy !== null && data.modifiedBy !== undefined) ? data.modifiedBy : null,
            ModifiedDate: data.modifiedDate ? new Date(data.modifiedDate) : null,
            OrderTypes: data.OrderTypes || '',
            touch: false
        });
    }

    editItem = (rowData, type) => {
        scrollToTop();

        if (!rowData || !rowData.menuItemSoldOutId) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Entry has error.' });
            return;
        }

        // Populate instantly from the grid row, then refine with the canonical single-record API
        this.populateForm(rowData, type);

        axios.get(`/master/api/res/Getmenuitemsoldoutbyid?companyid=${this.state.CompanyId}&Soldoutid=${rowData.menuItemSoldOutId}`)
            .then(response => {
                let data = Array.isArray(response.data) ? response.data[0] : response.data;
                if (data) {
                    this.populateForm(data, type);
                }
            })
            .catch(() => {
                // Row data already populated the form; ignore refresh failure
            });
    }

    change = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    onDropdownChange = (e) => {
        this.setState({ [e.target.name]: e.value, touch: true });
    }

    onCalendarChange = (name, value) => {
        this.setState({ [name]: value, touch: true });
    }

    onOverrideToggle = (e) => {
        const checked = e.value;
        this.setState({
            IsOverride: checked,
            OverrideQty: checked ? this.state.OverrideQty : '',
            touch: true
        });
    }

    toggleStatus = (rowData, checked) => {
        const status = checked ? 'SOLDOUT' : 'AVAILABLE';

        this.setState(prev => ({
            statusMap: { ...prev.statusMap, [rowData.menuItemSoldOutId]: status }
        }));

        // const data = {
        //     menuItemSoldOutId: rowData.menuItemSoldOutId,
        //     companyid: this.state.CompanyId,
        //     outletId: rowData.outletId,
        //     menuItemId: rowData.menuItemId,
        //     channelId: rowData.channelId || null,
        //     availabilityDate: rowData.availabilityDate,
        //     startTime: rowData.startTime,
        //     endTime: rowData.endTime,
        //     status: status,
        //     availableQty: (rowData.availableQty !== null && rowData.availableQty !== undefined) ? rowData.availableQty : null,
        //     soldQty: (rowData.soldQty !== null && rowData.soldQty !== undefined) ? rowData.soldQty : null,
        //     reasonCode: rowData.reasonCode || null,
        //     remarks: rowData.remarks || null,
        //     source: rowData.source,
        //     autoSoldOut: rowData.autoSoldOut === true,
        //     isOverride: rowData.isOverride === true,
        //     overrideQty: (rowData.overrideQty !== null && rowData.overrideQty !== undefined) ? rowData.overrideQty : null,
        //     createdBy: this.state.Createdby,
        //     createdDate: moment(this.state.Createddate).format('YYYY-MM-DD')
        // };

        const data = {
            companyid: this.state.CompanyId,
            outletId: this.state.OutletId,
            menuItemId: this.state.MenuItemId,

            channelId: this.state.ChannelId || null,

            availabilityDate: moment(this.state.AvailabilityDate).format('YYYY-MM-DD'),

            startTime: moment(this.state.StartTime).format('HH:mm:ss'),
            endTime: moment(this.state.EndTime).format('HH:mm:ss'),

            status: this.state.Status,

            availableQty:
                this.state.AvailableQty !== ''
                    ? Number(this.state.AvailableQty)
                    : null,

            soldQty:
                this.state.SoldQty !== ''
                    ? Number(this.state.SoldQty)
                    : null,

            reasonCode: this.state.ReasonCode || null,
            remarks: this.state.Remarks || null,
            source: this.state.Source || null,

            autoSoldOut: Boolean(this.state.AutoSoldOut),
            isOverride: Boolean(this.state.IsOverride),

            overrideQty:
                this.state.IsOverride && this.state.OverrideQty !== ''
                    ? Number(this.state.OverrideQty)
                    : null,

            createdBy: this.state.Createdby,
            createdDate: moment(this.state.Createddate).format('YYYY-MM-DD'),

            modifiedBy: this.state.ModifiedBy || null,

            modifiedDate: this.state.ModifiedDate
                ? moment(this.state.ModifiedDate).format('YYYY-MM-DD')
                : null,

            OrderTypes: this.state.OrderTypes || null
        };
        this.props.processDynamicData('Menuitemsoldout', 'edit', data, 'res/GetmenuitemsoldoutList?companyId=' + Companyid);
    }

    save = () => {
        if (this.state.OutletId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Outlet is required' });
            return;
        }
        if (this.state.MenuItemId === '') {
            this.growl.show({ severity: 'error', summary: null, detail: 'Menu Item is required' });
            return;
        }
        if (!this.state.AvailabilityDate) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Availability Date is required' });
            return;
        }
        if (!this.state.StartTime || !this.state.EndTime) {
            this.growl.show({ severity: 'error', summary: null, detail: 'Start Time and End Time are required' });
            return;
        }

        var data = {
            // menuItemSoldOutId:this.state.MenuItemSoldOutId,
            companyid: this.state.CompanyId,
            outletId: this.state.OutletId,
            menuItemId: this.state.MenuItemId,
            channelId: this.state.ChannelId || '',
            availabilityDate: moment(this.state.AvailabilityDate).format('YYYY-MM-DD'),
            startTime: moment(this.state.StartTime).format('HH:mm:ss'),
            endTime: moment(this.state.EndTime).format('HH:mm:ss'),
            status: this.state.Status,
            availableQty: this.state.AvailableQty !== '' ? this.state.AvailableQty : '',
            soldQty: this.state.SoldQty !== '' ? this.state.SoldQty : '',
            reasonCode: this.state.ReasonCode || '',
            remarks: this.state.Remarks || '',
            source: this.state.Source,
            autoSoldOut: this.state.AutoSoldOut,
            isOverride: this.state.IsOverride,
            overrideQty: (this.state.IsOverride && this.state.OverrideQty !== '') ? this.state.OverrideQty : '',
            createdBy: this.state.Createdby,
            createdDate: moment(this.state.Createddate).format('YYYY-MM-DD'),
            modifiedBy: this.state.ModifiedBy || '',
            modifiedDate: this.state.ModifiedDate || '',
            OrderTypes: this.state.OrderTypes || ''
        };

        if (this.state.type === 'edit') {
            data.menuItemSoldOutId = this.state.MenuItemSoldOutId;
        }

        this.props.processDynamicData('Menuitemsoldout', this.state.type, data, 'res/GetmenuitemsoldoutList?companyId=' + Companyid);

        setTimeout(() => {
            if (this.props.success !== null) {
                this.clear();
            }
        }, 3000);
    }

    clear = () => {
        this.setState({
            type: 'add',
            MenuItemSoldOutId: null,
            OutletId: '',
            MenuItemId: '',
            ChannelId: '',
            AvailabilityDate: null,
            StartTime: null,
            EndTime: null,
            Status: 'SOLDOUT',
            AvailableQty: '',
            SoldQty: '',
            ReasonCode: '',
            Remarks: '',
            Source: 'MANUAL',
            AutoSoldOut: false,
            IsOverride: false,
            OverrideQty: '',
            touch: false
        });
    }

    statusBody = (rowData) => {
        const status = this.state.statusMap[rowData.menuItemSoldOutId] ?? rowData.status;
        return (
            <InputSwitch
                checked={status === 'SOLDOUT'}
                onChange={(e) => this.toggleStatus(rowData, e.value)}
            />
        );
    }

    outletRender = (rowData) => this.lookupLabel(this.props.Branch, rowData.outletId);

    menuItemRender = (rowData) => this.lookupLabel(this.props.MenuItem, rowData.menuItemId);

    channelRender = (rowData) => this.lookupLabel(this.props.Channel, rowData.channelId);

    dateRender = (rowData) => rowData.availabilityDate ? moment(rowData.availabilityDate).format('DD-MMM-YYYY') : '';

    timeRender = (rowData) => {
        if (!rowData.startTime && !rowData.endTime) { return ''; }
        return `${rowData.startTime || ''} - ${rowData.endTime || ''}`;
    }

    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            {(this.getAccess !== undefined && this.getAccess.editAccess !== false) &&
                <Button onClick={() => this.editItem(rowData, 'edit')} type="button" icon="pi pi-pencil" className="p-button-info"></Button>
            }
            {(this.getAccess !== undefined && this.getAccess.viewAccess !== false) &&
                <Button type="button" icon="pi pi-eye" className="p-button-secondary" onClick={() => this.editItem(rowData, 'view')}></Button>
            }
        </div>;
    }

    render() {

        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false) { this.props.history.push('/dashboard'); }
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess: addAccess, editAccess: editAccess };

        let tableData = [];
        if (this.props.tableLists && this.props.tableLists.length > 0) {
            tableData = this.props.tableLists;
        }

        const header = (
            <div style={{ 'textAlign': 'right' }}>
                <InputText type="search" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder="Search..." />
            </div>
        );

        let isViewMode = this.state.type === 'view';

        let isEnabled = (this.state.touch === true) &&
            (this.state.OutletId !== '') &&
            (this.state.MenuItemId !== '') &&
            (this.state.AvailabilityDate !== null) &&
            (this.state.StartTime !== null) &&
            (this.state.EndTime !== null);

        return (
            <div className="p-grid padding">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>Menu Item Sold Out</h1>

                        <div className="p-grid mt1">

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Outlet <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Outlet" options={this.props.Branch} value={this.state.OutletId} name="OutletId" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Menu Item <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Menu Item" options={this.props.MenuItem} value={this.state.MenuItemId} name="MenuItemId" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Channel</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Select Channel" options={this.props.OrderType} value={this.state.ChannelId} name="ChannelId" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop">Availability Date <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Calendar className="width100" placeholder="Availability Date" value={this.state.AvailabilityDate} onChange={(e) => this.onCalendarChange('AvailabilityDate', e.value)} showIcon disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop">Start Time <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Calendar className="width100" placeholder="Start Time" timeOnly showTime value={this.state.StartTime} onChange={(e) => this.onCalendarChange('StartTime', e.value)} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="labeltop">End Time <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Calendar className="width100" placeholder="End Time" timeOnly showTime value={this.state.EndTime} onChange={(e) => this.onCalendarChange('EndTime', e.value)} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Status <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Status" options={this.statusOptions} value={this.state.Status} name="Status" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Source</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Source" options={this.sourceOptions} value={this.state.Source} name="Source" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Reason Code</label>
                                <div className="mt1">
                                    <Dropdown className="p-col-12" placeholder="Reason Code" options={this.reasonCodeOptions} value={this.state.ReasonCode} name="ReasonCode" onChange={this.onDropdownChange} {...DROPDOWN_CONFIG} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Available Qty</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" type="number" name="AvailableQty" placeholder="Available Qty" value={this.state.AvailableQty} onChange={this.change} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Sold Qty</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" type="number" name="SoldQty" placeholder="Sold Qty" value={this.state.SoldQty} onChange={this.change} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Remarks</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" name="Remarks" placeholder="Remarks" value={this.state.Remarks} onChange={this.change} disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Auto Sold Out</label>
                                <div className="mt1">
                                    {/* <InputSwitch checked={this.state.AutoSoldOut} onChange={this.change} name="AutoSoldOut" disabled={isViewMode} /> */}

                                    <InputSwitch
                                        checked={this.state.AutoSoldOut}
                                        onChange={(e) =>
                                            this.setState({
                                                AutoSoldOut: e.value,
                                                touch: true
                                            })
                                        }
                                        disabled={isViewMode}
                                    />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Override</label>
                                <div className="mt1">
                                    <InputSwitch checked={this.state.IsOverride} onChange={this.onOverrideToggle} name="IsOverride" disabled={isViewMode} />
                                </div>
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-4">
                                <label className="label">Override Qty</label>
                                <div className="mt1">
                                    <InputText className="p-col-12" type="number" name="OverrideQty" placeholder="Override Qty" value={this.state.OverrideQty} onChange={this.change} disabled={isViewMode || !this.state.IsOverride} />
                                </div>
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.save} reset={this.clear} to="" />
                            </div>

                            <div className="p-col-12" style={{ marginTop: '2em' }}>
                                <DataTable ref={(el) => this.dt = el} value={tableData} globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG}>
                                    <Column body={this.outletRender} header="Outlet" />
                                    <Column body={this.menuItemRender} header="Menu Item" />
                                    <Column body={this.channelRender} header="Channel" />
                                    <Column body={this.dateRender} header="Availability Date" sortable />
                                    <Column body={this.timeRender} header="Time" />
                                    <Column field="status" header="Sold Out" body={this.statusBody} />
                                    <Column field="source" header="Source" />
                                    <Column body={this.actionTemplate} header="Action" />
                                </DataTable>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        Branch: (state.keyword.Branch !== undefined) ? state.keyword.Branch : [],
        MenuItem: (state.keyword.MenuItem !== undefined) ? state.keyword.MenuItem : [],
        OrderType: (state.keyword.OrderType !== undefined) ? state.keyword.OrderType : [],
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, company) => dispatch(actions.getMasterTableList(table, company)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Soldout);
